import { SalesAgreement, SalesAgreementProductLine } from '../storage'

function isSalesAgreement(x: SalesAgreementProductLine | SalesAgreement): x is SalesAgreement {
  return (x as SalesAgreement).totalCommitted !== undefined
}

export const getAvailableQuantity = (x: SalesAgreementProductLine | SalesAgreement) => {
  if (isSalesAgreement(x)) {
    const availableAmount = x.totalCommitted - x.totalInvoiced - x.totalFulfilled - x.totalReleased
    return availableAmount
  } else {
    const availableAmount = x.quantity.remaining
    return availableAmount
  }
}
